import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useAemConfig } from '@as-react/common-components';
import { basketMutations } from '@as-react/common-queries';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { VoucherBlock } from '../voucher/VoucherBlock';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { makeGetBasketValidateRegexState } from '../../../redux/basket/selectors/BasketSelector';
import { basketActions } from '../../../redux/basket/actions/BasketActions.creators';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { useBasketOverviewConfig } from '../../../context/ComponentConfigContext';
export const BasketOverviewVoucher = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const { totalMiniBlock } = useBasketOverviewConfig();
    const { defaultRequestParams, servicesEndpoint, isShopLanding } = useAemConfig();
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const dispatch = useDispatch();
    const validateRegex = useSelector(makeGetBasketValidateRegexState());
    const { postVoucher } = basketMutations({ servicesEndpoint, defaultRequestParams });
    const { mutateAsync: postVoucherMutation } = useMutation(postVoucher);
    const handleVoucherSubmit = (code, webcode) => __awaiter(void 0, void 0, void 0, function* () {
        return yield postVoucherMutation({ code, webcode });
    });
    const handleVoucherAddSuccess = () => {
        dispatch(basketActions.createGetAction());
    };
    const handleVoucherAddError = (message) => {
        message && dispatch(analyticsActions.formsErrorMessage({ voucher_code: message }));
    };
    const handleVoucherFieldsError = (errors) => {
        dispatch(analyticsActions.formsErrorMessage(errors));
    };
    const openByDefault = !(isDesktop
        ? totalMiniBlock === null || totalMiniBlock === void 0 ? void 0 : totalMiniBlock.isVoucherCodeCollapsedOnDesktop
        : totalMiniBlock === null || totalMiniBlock === void 0 ? void 0 : totalMiniBlock.isVoucherCodeCollapsedOnMobileTablet);
    if (isShopLanding)
        return null;
    return (_jsx(VoucherBlock, { isOpenByDefault: openByDefault, onAddError: handleVoucherAddError, onAddSuccess: handleVoucherAddSuccess, onSubmit: handleVoucherSubmit, onFieldsError: handleVoucherFieldsError, validateRegex: validateRegex, submitButtonLabel: t('checkout.basket.voucher.submit') }));
};
